import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';
import { SignupPlanPaymentsComponent } from '../../components/signup-plan-payments/signup-plan-payments.component';

@Component({
  selector: 'app-incom-prof',
  templateUrl: './incom-prof.component.html',
  styleUrls: ['./incom-prof.component.scss']
})
export class IncomProfComponent implements OnInit {

  incompletelogin : any;
  loginData: any;
  signUpDetails = false;
  userPrice:any;
  priceEx:any;
  leadId: any;

  signUpBlock: boolean = false
  subPlanDetails: any;

  constructor(
    private _dialogRef: MatDialogRef<IncomProfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService,
    private activeRoute: ActivatedRoute,
    private subscriptionPlansService: SubscriptionPlansService,
    private _dialog: MatDialog,
    private router: Router,
  ) { }
  ngOnInit(): void {
    localStorage.setItem('incompletelogin', '1');
    this.userPrice = localStorage.getItem('selPrice');
    this.priceEx = localStorage.getItem('disValue');
    console.log('running modal')
  }
  dialogClose(): void {
    
   // document.getElementsByClassName('animate__animated')[0].classList.remove('animate__fadeInDown')
   // document.getElementsByClassName('animate__animated')[0].classList.add('animate__fadeOutUp');
    setTimeout(() => { this._dialogRef.close(); }, 1000);

    this.incompletelogin =localStorage.getItem("incompletelogin"); 

    this.loginData = this.loginService.getLoginDataDirectory()    
    if(!this.loginData){
      var log = localStorage.getItem('logInfo');
      this.loginData = JSON.parse(log);
    }

    if(!this.loginData){
      this.signUpDetails = true;
    }

          
      this.subscriptionPlansService.getSubPlanById(this.data?.present_subscription_id).subscribe(data => {

        console.log('Sub Plan Details--->',data)

        this.signUpBlock = true
        this.subPlanDetails = data
        this.subPlanDetails.price_in_aud = JSON.parse(this.userPrice)
        this.subPlanDetails.priceExten = this.priceEx;
        this.subPlanDetails.leadId = this.data?.id;
        this.leadId = this.data?.id;

        localStorage.setItem('subPlanDetails', this.subPlanDetails);

        if (this.loginData?.id) {
          if (this.loginData.type == "SUPPLIER") {


            if (this.leadId && this.subPlanDetails.price_in_aud && this.subPlanDetails.price_in_aud !== 0) {
              this._dialog.open(SignupPlanPaymentsComponent, {
                width: '30%',
                panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
                disableClose: true,
                data: {
                  leadId: this.leadId,
                  planDetails: this.subPlanDetails
                }
              })
            }else{
              this.signUpDetails = true;
              this._dialogRef.close();
              //this.router.navigate(['profile/detail']);
            }
          }
        }
    
      });
    
  }
}
